module.exports = __webpack_public_path__ + "static/media/Akkurat.19572d82.woff2";